import { PaletteMode, PaletteOptions } from '@mui/material';
import { GetThemeOptions } from '../theme';
import { unitySemanticDarkColorTokens, unitySemanticLightColorTokens } from '../unityTokens';
import { border } from './border';
import { green, white } from './colors';
import {
  buildPaletteFromMetadata,
  nonColorPaletteToken,
  PaletteTokenMetadata,
  Token,
} from './panw-palette/token-metadata';

/** For use strictly within @chronosphereio/chrono-ui and @chronosphereio/viz-framework */
const inputTokens = [
  { propertyPath: 'backgroundColor', tokenName: '--semantic-bg-input-default' },
  { propertyPath: 'borderColor', tokenName: nonColorPaletteToken('transparent') },
  { propertyPath: 'disabledBackgroundColor', tokenName: '--semantic-bg-input-disabled' },
  { propertyPath: 'errorColor', tokenName: '--semantic-text-destructive' },
  { propertyPath: 'focusBorderColor', tokenName: nonColorPaletteToken('transparent') },
  { propertyPath: 'hoverBackgroundColor', tokenName: '--semantic-bg-interactive-neutral-hover' },
  { propertyPath: 'hoverBorderColor', tokenName: nonColorPaletteToken('transparent') },
  { propertyPath: 'labelColor', tokenName: '--semantic-text-placeholder' },
  { propertyPath: 'placeholderColor', tokenName: '--semantic-text-placeholder' },
  { propertyPath: 'selected', tokenName: '--semantic-bg-interactive-neutral-active' },
] satisfies Token[];

export const inputTokenMetadata: PaletteTokenMetadata = {
  componentName: 'input',
  tokens: inputTokens,
};

export const input = (mode: PaletteMode, opts: GetThemeOptions): PaletteOptions['input'] => {
  if (opts.panwRebrandStubYear) {
    const tokens = mode === 'light' ? unitySemanticLightColorTokens : unitySemanticDarkColorTokens;
    return buildPaletteFromMetadata(inputTokenMetadata.tokens, tokens);
  }

  const borderPalette = border(mode, opts)!;
  return mode === 'light'
    ? {
        backgroundColor: white,
        borderColor: borderPalette.bold,
        selected: green[50],
      }
    : {
        backgroundColor: 'inherit',
        borderColor: borderPalette.bold,
        selected: green[800],
      };
};
